import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from "../services/authentication.service";
import {User} from "../models/user";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
    selector: 'app-profile-details',
    templateUrl: './profile-details.component.html',
    styleUrls: ['./profile-details.component.css'],
    standalone: false
})
export class ProfileDetailsComponent implements OnInit {
  user!: User;
  profileForm= new FormGroup({
    userName: new FormControl<string>('',
      [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern('^[a-zA-Z-]*$')
      ])
  });
  formSubmitted = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthenticationService
  ) {}

  async ngOnInit() {
    this.user = await this.authService.getUser();
    this.profileForm.controls['userName'].setValue(this.user.name);
  }

  async changeUsername() {
    if(!this.profileForm.valid) {
      this.formSubmitted = false;
      return;
    }

    await this.authService.changeUserDetails(this.user.uid, <string>this.profileForm.controls['userName'].value);
    this.formSubmitted = true;
  }

  /**
   * @return Filled in username value on profile form.
   */
  get userName() {
    return this.profileForm.get('userName');
  }
}
